module.exports = __webpack_public_path__ + "static/screenshot5@2x-0599a71e7d8cef0c6f67bf3cba7b9dc0.jpg";